
import { Select } from "antd";
import { RadioGroup, Button, Tooltip } from 'components';
import { ReactComponent as Info } from 'assets/icons/info-icon.svg';
const { Option } = Select;


export const formFields1 = [
      
      {
        label: 'Εισάγετε τον λόγο για τον οποίο υποβάλλετε ένσταση',
        id: 'objCommentBen',
        type: 'textarea',
        name: 'objCommentBen',
        size: 'large',
        placeholder: 'Εισάγετε Αιτιολόγηση',
        rows: 15,
        simple: true,
        span: 24,
        maxLength: 500,
        rules: [
          { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
          // { max: 100 , message: 'Το πεδίο μπορεί να έχει το πολύ 100 χαρακτήρες' },
        ],
        asterisk: true,
      }, 
]

export const formFields2 = [
    {
        label: 'Έντυπα Τεκμηρίωσης',
        fileCode: 'objBenDocs',
        id: 'objBenDocs',
        multiple: true,
        fileLimit: 10
      },
]
